<template>
  <span>{{text}}</span>
</template>
<script>
export default {
  props: ['url', 'value', 'itemValue', 'itemText'],
  data() {
    return {
      items: []
    }
  },
  computed: {
    text() {
      let k = this.itemValue || 'value'
      let v = this.itemText || 'text'
      if (!Array.isArray(this.value)) {
        let item = this.items.find(i => i[k] === this.value)
        return item && item[v]
      } else {
        return this.items
          .filter(i => this.value.indexOf(i[k]) !== -1)
          .map(i => i[v])
          .join(', ')
      }
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(this.url).then(res => (this.items = res.data))
    }
  }
}
</script>

